import { render, staticRenderFns } from "./LocationPages.vue?vue&type=template&id=028d75f1&scoped=true"
import script from "./LocationPages.vue?vue&type=script&lang=js"
export * from "./LocationPages.vue?vue&type=script&lang=js"
import style0 from "./LocationPages.vue?vue&type=style&index=0&id=028d75f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028d75f1",
  null
  
)

export default component.exports